export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    big_win: [
      0,
      4770.249433106576,
    ],
    button_spin: [
      6000,
      506.4852607709751,
    ],
    end_port_fs_win: [
      8000,
      5283.990929705215,
    ],
    free_bet_big_win: [
      15000,
      1377.2335600907013,
    ],
    free_bet_mega_win: [
      18000,
      2213.151927437643,
    ],
    free_bet_total_win: [
      22000,
      979.591836734695,
    ],
    free_bet_ultra_win: [
      24000,
      1319.1836734693893,
    ],
    free_spin_ambient: [
      27000,
      38598.82086167801,
    ],
    free_spin_music: [
      67000,
      51574.42176870748,
    ],
    free_spin_start: [
      120000,
      2252.335600907031,
    ],
    inside_buttons: [
      124000,
      285.89569160997996,
    ],
    loop_port_fs_win: [
      126000,
      2567.256235827671,
    ],
    main_ambient: [
      130000,
      54635.102040816324,
    ],
    main_music: [
      186000,
      128001.4512471655,
    ],
    mega_win: [
      316000,
      6871.65532879817,
    ],
    outside_buttons: [
      324000,
      245.26077097505095,
    ],
    reel_spin: [
      326000,
      2292.9705215419744,
    ],
    reel_stop_01: [
      330000,
      94.33106575966121,
    ],
    reel_stop_02: [
      332000,
      94.33106575966121,
    ],
    reel_stop_03: [
      334000,
      87.07482993196436,
    ],
    reel_stop_04: [
      336000,
      91.42857142859384,
    ],
    reel_stop_05: [
      338000,
      85.6235827664591,
    ],
    scatter_stop: [
      340000,
      1446.8934240362614,
    ],
    start_port_fs_win: [
      343000,
      7234.467120181421,
    ],
    sticky_wild_start: [
      352000,
      1748.7528344670977,
    ],
    tap_to_play: [
      355000,
      2416.3265306122526,
    ],
    total_win: [
      359000,
      1359.818594104297,
    ],
    ultra_win: [
      362000,
      5371.06575963719,
    ],
    wild_stop: [
      369000,
      1383.038548752836,
    ],
  },
}
